module.exports = __webpack_public_path__ + "img/胡桐泪.6a597d04.jpg";